export const RETURN_LOCATION_ADMIN_SIGNUP = 'ADMIN_SIGNUP';

export const RETURN_LOCATION_SETTINGS = 'SETTINGS';

export const ERROR_CODE_DUPLICATE_ORG = 15;
export const ERROR_CODE_DUPLICATE_DOMAIN = 18;
export const ERROR_CODE_TOKEN_EXPIRED = 7;
export const ERROR_CODE_TOKEN_INVALID = 10;
